import React, { useState, useEffect } from "react";
import "../App.css";

const ImageSlider = ({ events }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? events.length - 1 : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === events.length - 1 ? 0 : prevIndex + 1,
    );
  };

  // Automatically change the event every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === events.length - 1 ? 0 : prevIndex + 1,
      );
    }, 15000); // 15 seconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [events.length]);

  if (events.length === 0) {
    // TODO (kyle): Change this so there is an appealing fallback when events is empty - add a default event data
    return <p>No events to display</p>;
  }

  const currentEvent = events[currentIndex];

  return (
    <div className="image-slider-container">
      <div className="image-slider">
        <button className="slider-button left-button" onClick={handlePrevious}>
          &#8592; {/* Left Arrow */}
        </button>
        <div className="slider-content-container">
          <img
            src={currentEvent.pic_url}
            alt={currentEvent.event_name}
            className="slider-image"
          />
          <div className="slider-textbox">
            <h3>{currentEvent.event_name}</h3>
            <p>{currentEvent.event_description}</p>
          </div>
        </div>
        <button className="slider-button right-button" onClick={handleNext}>
          &#8594; {/* Right Arrow */}
        </button>
      </div>
    </div>
  );
};

export default ImageSlider;
